<template>
  <div class="media-view-components" v-if="isShowPaper" :class="{'showPaper': isShowPaper}">
    <div class="media-view-flash">
      <i class="el-icon-circle-close" @click="closePaper"></i>
      <div id="js-flexpaper-view" class="flexpaper_viewer">
        <div v-show="!hasFlash">
          您没有启用flash，点击<a href="http://www.adobe.com/go/getflashplayer" style="color:#10ae58;" rel="nofollow" target="_blank" title="升级Flash插件">启用flash</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import detectFlash from '../../static/js/media-view/detectFlash'

export default {
  data () {
    return {
      isShowPaper: false,
      hasFlash: detectFlash()
    }
  },
  mounted () {
    this.mv = new window.MediaView({
      selector: '#mediaview'
    })
  },
  methods: {
    closePaper () {
      this.isShowPaper = false
      window.jQuery(window).off('keyup', this.keyUp)
      window.jQuery('body').removeClass('mediaview-frozen')
    },
    keyUp (e) {
      if (e.keyCode === 27) {
        this.closePaper()
      }
    }
  },
  computed: mapState({
    media: state => state.media
  }),
  watch: {
    'media.isPlay': function (val) {
      if (val) {
        if (this.media.mode === 'doc') {
          let src = this.media.src
          this.isShowPaper = true
          window.jQuery(window).on('keyup', this.keyUp)
          window.jQuery('body').addClass('mediaview-frozen')
          if (!this.hasFlash) { return }
          this.$nextTick(() => {
            window.jQuery(`#js-flexpaper-view`).FlexPaperViewer(
              { config: {
                SWFFile: src,
                Scale: 1,
                jsDirectory: './static/preview/js/',
                ZoomTransition: `easeOut`,
                ZoomTime: 0.5,
                ZoomInterval: 0.2,
                FitPageOnLoad: true,
                FitWidthOnLoad: true,
                FullScreenAsMaxWindow: false,
                ProgressiveLoading: false,
                MinZoomSize: 0.2,
                MaxZoomSize: 5,
                SearchMatchAll: false,
                InitViewMode: `Portrait`,
                RenderingOrder: `flash`,
                StartAtPage: ``,
                ViewModeToolsVisible: true,
                ZoomToolsVisible: true,
                NavToolsVisible: true,
                CursorToolsVisible: true,
                SearchToolsVisible: true,
                WMode: `window`,
                localeChain: `cn_ZH`
              }}
            )
          })
        } else {
          this.mv.view(Object.assign({}, this.media))
        }
        this.$store.commit('PLAY_MEDIA', {
          isPlay: false,
          mode: '',
          src: '',
          poster: '',
          title: '',
          type: ''
        })
      }
    }
  }
}
</script>

<style scoped>
.media-view-components {
  position: relative;
}
.showPaper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 998;
}
.media-view-flash {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -430px;
  margin-top: -241px;
  width: 856px;
  height: 482px;
}
.flexpaper_viewer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.el-icon-circle-close {
  position: absolute;
  right: -15px;
  top: -15px;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  top: -10px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/mediaView.vue